export const appLegalName = "Green Unison Limited";
export const appTIN = "31670626-0001";

export const appTitle = "Green Unison Nigeria - Natural Herbs, Foods & Skincare";
export const appShortName = "Green Unison";
export const appDescription =
    "Naturally grown and responsibly prepared herbs, spices, flours, seeds, seedlings, botanical waters, plant oils, and skincare essentials — with renewable energy guiding every step, from farm to package.";

export const appIcon = "src/images/favicon.png";
export const appOgImage = "https://apis.greenunison.com/shop/images/og/green-unison-eshop.jpg";

export const appOriginUrl = "https://greenunison.com";
export const appUrl = `${appOriginUrl}/`;

export const appGoogleBusinessUrl = "https://share.google/ZkYwc3CfJlxwqcezf";

export const appHandle = "@greenunison";
export const appFacebook = "https://www.facebook.com/greenunison";
export const appInstagram = "https://www.instagram.com/greenunison";
export const appX = "https://x.com/greenunison";
export const appTikTok = "https://www.tiktok.com/@greenunison";
export const appYoutube = "https://www.youtube.com/@greenunison";

export const appAddress = "65, Old Ibadan Road, Iperu Remo, Ogun State";
export const appGoogleMapsUrl = "https://maps.app.goo.gl/vWaKedwPNyysg8x69";

export const appWhatsAppUrl = "https://wa.me/2348103043789";
export const appEmail = "mail@greenunison.com";
export const appCustomerServiceEmail = "support@greenunison.com";
export const appPhone = "+2348103043789";
